<template>
  <component :is="activeNavbar" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import MarketingNavbar from '@/components/layout/MarketingNavbar.vue'
import AppNavbar from '@/components/layout/AppNavbar.vue'

const route = useRoute()

// App Mode detection
const isAppMode = computed(() => route.meta.compactNavbar === true)

const activeNavbar = computed(() => {
  return isAppMode.value ? AppNavbar : MarketingNavbar
})
</script>
